import type { DateRange } from '@/components/base/DateRangePicker';

export interface OrderFilters {
  range: DateRange;
  priority: string;
  delivery: string;
  source: string;
  search: string;
}

export const emptyFilters: OrderFilters = {
  range: { from: '', to: '' },
  priority: '',
  delivery: '',
  source: '',
  search: '',
};

export interface OrderActionHandlers {
  onAccept: (orderId: string) => void;
  onReject: (orderId: string) => void;
  onStart: (orderId: string) => void;
  onReady: (orderId: string) => void;
  onComplete: (orderId: string) => void;
  onAssign: (orderId: string) => void;
}